export const NOTES_TYPES = {
  LOAD_NOTES: "LOAD_NOTES",
  SET_NOTES: "SET_NOTES",
  CLEAR_NOTES: "CLEAR_NOTES",
  HANDLE_NOTES_BUILDINGS_INPUTS: "HANDLE_NOTES_BUILDINGS_INPUTS",
};
